var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":_vm.hasErrors,"variant":"danger"}},[_c('ul',{staticClass:"list-unstyled mb-0"},[_vm._l((_vm.errors),function(Errors){return _vm._l((Errors),function(error){return _c('li',[_vm._v("\n          "+_vm._s(error)+"\n        ")])})})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }